import { ApiError, isApiErrorStatus } from '../services/api/http';

export const errorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return fallback;
};

type Translate = (key: string) => string;

export const rateLimitErrorMessage = (error: unknown, fallback: string, t: Translate): string => {
  if (!isApiErrorStatus(error, 429)) {
    return errorMessage(error, fallback);
  }

  const retryAfterSeconds = error instanceof ApiError && error.retryAfterSeconds && error.retryAfterSeconds > 0
    ? error.retryAfterSeconds
    : undefined;
  const message = t(retryAfterSeconds ? 'common.rateLimitWithRetry' : 'common.rateLimit');
  return message.replace('{seconds}', String(retryAfterSeconds ?? ''));
};
